module.exports = __webpack_public_path__ + "img/icon2.218a86eb.svg";